import React, { useEffect, useState } from 'react';
import ArticleCard from '../ArticleCard';
import ScrollableRow from '../../utils/ScrollableRow';
import axios from 'axios';


const ArticlesRow = () => {

    const [loading, setLoading] = useState(true);
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            setLoading(true);
            const { data } = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/blogs`);
            if (data.success) {
                setBlogs(data.blogs);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="articlesSection">
            <section className="mainSection">
                <ScrollableRow
                    title="Our Top Articles"
                    items={blogs}
                    itemsPerRow={4}
                    renderItem={(article, index) => <ArticleCard
                        key={index}
                        title={article.title}
                        date={article.date}
                        image={article.image}
                        category={article.category}
                        slug={article.slug}
                    />}
                    isLoading={loading}
                    noItemsMessage="No articles available to show here."
                />
            </section>
        </section>
    );
};

export default ArticlesRow;